import "./Navbar.scss";
import {
    MDBBtn,
    MDBContainer,
    MDBNavbar,
    MDBNavbarBrand, MDBNavbarItem, MDBNavbarLink, MDBNavbarNav
} from 'mdb-react-ui-kit';

import { useDispatch } from 'react-redux'
import { showModal } from '../../modalSlice'

const Logo = "https://cdn.deepsense.space/Ripple/World/logo.png";


export const Navbar = (props) => {
    const dispatch = useDispatch()
    return(
        <>
            <div className={"navbar-component"}>
                <div id="scrollspy1" className="sticky-top">
                    <MDBNavbar expand='lg' >
                        <MDBContainer fluid className={"p-0"}>
                            <MDBNavbarBrand href='#'>
                                <img
                                    src={Logo}
                                    height={'40'}
                                    alt=''
                                    loading='lazy'
                                />
                            </MDBNavbarBrand>
                            <MDBNavbarNav right fullWidth={false} className='mr-auto hide-xs-navbar-nav'>
                                    <MDBNavbarItem>
                                        <MDBNavbarLink active aria-current='page' href='#industry-verticals'>
                                            Industry Verticals
                                        </MDBNavbarLink>
                                    </MDBNavbarItem>
                                    {/*<MDBNavbarItem>*/}
                                    {/*    <MDBNavbarLink active aria-current='page' href='#what-we-done'>*/}
                                    {/*        What we done ?*/}
                                    {/*    </MDBNavbarLink>*/}
                                    {/*</MDBNavbarItem>*/}
                                    <MDBNavbarItem>
                                        <MDBNavbarLink active aria-current='page' href='#insights'>
                                            Insights
                                        </MDBNavbarLink>
                                    </MDBNavbarItem>
                                    <MDBNavbarItem>
                                        <MDBNavbarLink active aria-current='page'>
                                            <div className={"contact-us-btn-section"}>
                                                <MDBBtn tag='div' color='none' className={"contact-us-btn"}  type='button'
                                                        onClick={() => dispatch(showModal())}
                                                >
                                                    Contact us
                                                </MDBBtn>
                                            </div>
                                        </MDBNavbarLink>
                                    </MDBNavbarItem>
                                </MDBNavbarNav>
                            <MDBNavbarNav right fullWidth={false} className='mr-auto show-xs-navbar-nav'>
                                <MDBNavbarItem>
                                    <MDBNavbarLink active aria-current='page'
                                                   onClick={() => dispatch(showModal())}
                                    >
                                        Contact us
                                    </MDBNavbarLink>
                                </MDBNavbarItem>
                            </MDBNavbarNav>
                        </MDBContainer>
                    </MDBNavbar>
                </div>
            </div>
        </>
    )
}
